// extracted by mini-css-extract-plugin
export var fadeIn = "_ax-0";